import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
import { isSubmitting } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// constants
import { Forms } from 'constants/index'
import { REVIEW_STATUSES } from 'constants/review'
// view components
import CreateReviewForm from 'components/Modals/CreateReviewModal/components/ReviewDetails/components/Form'
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
// context
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'
// graphql
import { REVIEW_ACTIVITIES_LIST_QUERY } from 'graphql/reviews/queries'
// views
import { ButtonsWrapper, Paper, Scrollbar, Wrapper } from './views'
// utils
import { get } from 'lodash'
import { mapReviewPicklistsToFormValues } from 'utils/reviews'
// types
import { LogEntityTypes } from 'types/graphql'

const ReviewDetails: React.FC = () => {
  const {
    review,
    questions,
    picklists,
    beforeUpload,
    isReviewUpdate,
    handleSaveDraft,
    handleFormSubmit,
    handleCreateReview
  } = React.useContext(CreateReviewBLContext)

  const initialValues = {
    goals: get(review, 'values.goals'),
    doWell: get(review, 'values.doWell'),
    doBetter: get(review, 'values.doBetter'),
    picklists: mapReviewPicklistsToFormValues(picklists, review)
  }

  const isReviewInProgress = get(review, 'status') === REVIEW_STATUSES.IN_PROGRESS
  const isReviewComplete = get(review, 'status') === REVIEW_STATUSES.COMPLETE

  const submitting = useSelector((state) => isSubmitting(Forms.CREATE_REVIEW_FORM)(state))

  return (
    <Paper>
      <Scrollbar>
        <Wrapper container direction={'column'} wrap={'nowrap'}>
          <CreateReviewForm
            questions={questions}
            picklists={picklists}
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
          />
          <ActivitiesListContainer
            beforeUpload={!get(review, 'id') && beforeUpload}
            isReviewDetails
            disableDrag
            skip={!get(review, 'id')}
            entity={{ id: review.id, entityType: LogEntityTypes.Review }}
            query={REVIEW_ACTIVITIES_LIST_QUERY}
            variables={{
              filter: { entityId: review.id }
            }}
          />
        </Wrapper>
      </Scrollbar>

      <ButtonsWrapper isReviewInProgress={isReviewInProgress}>
        <Button
          type={'button'}
          isLoading={submitting}
          layout={BUTTON_LAYOUTS.PURPLE}
          onClick={handleCreateReview}>
          {isReviewUpdate && !isReviewInProgress ? 'Submit changes' : 'Submit review'}
        </Button>
        {!isReviewComplete && (
          <Button type={'button'} layout={BUTTON_LAYOUTS.WHITE} onClick={handleSaveDraft}>
            {isReviewInProgress ? 'Submit changes' : 'Save draft'}
          </Button>
        )}
      </ButtonsWrapper>
    </Paper>
  )
}

export default ReviewDetails
